// loginHint — the email the sign-in page passes to Auth0 as `login_hint`, so
// the provider's page opens with it filled in. Sign-in itself stays Auth0's.
//
// Parsed at BOTH boundaries: the sign-in form (to say "that is not an email
// address" before leaving) and the server's login route (the query value is
// untrusted input). A hint is only ever a convenience: an absent or invalid
// one means "no hint", never an error the sign-in depends on. The address is
// the domain's own `Account.Email` (normalised there). Pure: no I/O. Exposed
// as `@bilda/app/loginHint`.
export { loginHintParam, parseLoginHint };
import * as Core from "@bilda/core";
import { Result } from "@bilda/utils";
const loginHintParam = "login_hint";
// RFC 5321 caps an address at 254 characters; longer is junk, not a hint.
const MAX_LENGTH = 254;
const parseLoginHint = (raw) => {
    const value = (raw ?? "").trim();
    if (value === "")
        return { type: "empty" };
    if (value.length > MAX_LENGTH)
        return { type: "invalid" };
    const email = Core.Account.Email.to(value);
    return Result.isOk(email)
        ? { type: "email", hint: email.value }
        : { type: "invalid" };
};
//# sourceMappingURL=loginHint.js.map